export const BASIC_AUTHENTICATION_ERROR = {
  REQUIRED: "{{NAME}} is required",
  NAME: "Full Name must be at least 3 characters",
  EMAIL: "Enter a valid email address",
  PASSWORD: "Password must be at least 6 characters",
  CONFIRM_PASSWORD: "Passwords must match",
  MSG_EMAIL_LENGTH: "Email should not be of more than 254 characters",
  MSG_EMAIL_USERNAME_REQ: "Email is mandatory",
  MSG_PASSWORD_TYPE:
    "Password should be a minimum 8 characters",
  MSG_REQUIRED_PASSWORD: "Password is mandatory",
  AGREE_TERMS_CONDITION: "You must agree to the terms and conditions",
};

export const USER_ERROR_MESSAGE = {
  FAILED_TO_FETCH_DATA: "Failed to fetch data.",
  NO_RECENT_SEARCH: "No recent searches",
  NO_DATA_FOUND: "No data found",
  NO_BROWSE_DATA: "No results found for your search. Please try a different keyword.",
}

export const ERROR_MESSAGES = {
  NO_TRIP_NO_SIZE: "Select a size and create a trip before adding to your bag!",
  NO_TRIP: "Create a trip before adding pieces to your bag!",
  NO_SELECTED_TRIP_NO_SIZE: "Select a size and create/select a trip before adding piece to your bag!",
  NO_SELECTED_TRIP: "Select/Create trip before adding pieces to your bag!",
  NO_SIZE: "Select a size to add this piece to your bag!",
  NO_COLOR: "Select color to add pieces to your bag!",
};


